"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageUppercase = exports.Languages = void 0;
var Languages;
(function (Languages) {
    Languages["fr"] = "fr";
    Languages["en"] = "en";
})(Languages || (exports.Languages = Languages = {}));
var LanguageUppercase;
(function (LanguageUppercase) {
    LanguageUppercase["FR"] = "FR";
    LanguageUppercase["EN"] = "EN";
})(LanguageUppercase || (exports.LanguageUppercase = LanguageUppercase = {}));
//# sourceMappingURL=languages.js.map